<template>
        <div class="box">
                <!-- 遮罩 -->
                <!-- <div class="box1"  @click="Hidden" > -->
                <div class="box1">


                </div>
                <!-- 内容 -->
                <div class="box2">
                   <slot></slot>
                </div>
            </div>
</template>
<script>
export default {
    data(){
        return{
        }
    },
    methods:{
        Hidden(){
            this.$emit('hidden')
        }
    }
}
</script>
<style lang="scss" scoped>
.box{

}


.box1{
    position: fixed;
    top: 0;
    width: 100%;
    height: 100vh;
    background: #000;
    opacity: .5;
    z-index: 999;
}

@keyframes mybox2{
    0% {
        opacity: 0;

    }
    100%{


    }


}

.box2{
    width: 301px;
    height: 430px;

    border-radius: 8px;
    z-index: 9999;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    // padding: 0 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    box-sizing: border-box;
    animation: mybox2 .5s;
}



</style>
